import * as React from "react"
import * as ReactDOM from "react-dom"

interface IOpportunitiesProps {
    OpenInNewWindow: boolean;
    Step1:string;
    Step2:string;
    Step3:string;
    Step4:string;
    Step5:string;
    Step1Link:string;
    Step2Link:string;
    Step3Link:string;
    Step4Link:string;
    Step5Link:string;
    ButtonText: string;
    itemProperties: {
        Title: string;
        Description: string;
        ImageSource: string;
        Url:string;

    };
    initialState: OpportunitiesModel<OpportunitiesItemModel>;
}

class OpportunitiesModel<T> {
    OpenInNewWindow: boolean;
    Step1:string;
    Step2:string;
    Step3:string;
    Step4:string;
    Step5:string;
    Step1Link:string;
    Step2Link:string;
    Step3Link:string;
    Step4Link:string;
    Step5Link:string;
    items: Array<T>;
    constructor() {
        this.items = new Array<T>();
    }
}

class OpportunitiesItemModel {
    Title: string;
    Description: string;
    ImageSource: string;
    Url:string;
}

export class Opportunities extends React.Component<IOpportunitiesProps, OpportunitiesModel<OpportunitiesItemModel>>{
    constructor(props: IOpportunitiesProps) {
        super(props);
        this.state = (!this.props.initialState) ? new OpportunitiesModel<OpportunitiesItemModel>() : this.props.initialState;
    }

    componentDidMount() {
    }


    render() {
        return <section className="section-steps">
            <div className="steps steps-top">
                <ul className="steps-list">
                    <li><a href={this.state.Step1Link ? this.state.Step1Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step1}</a></li>
                    <li><a href={this.state.Step2Link ? this.state.Step2Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step2}</a></li>
                    <li><a href={this.state.Step3Link ? this.state.Step3Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step3}</a></li>
                    <li><a href={this.state.Step4Link ? this.state.Step4Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step4}</a></li>
                    <li><a href={this.state.Step5Link ? this.state.Step5Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step5}</a></li>

                </ul>
            </div>
            <div className="container ">
                <div className="row">
                    {this.state.items.map((value, index, array) => {
                        return <div className="col-lg-2 ">
                            <div className="sc-box">
                            <a href={value.Url ? value.Url : "#"}>
                                <img src={`${value.ImageSource}`} className="img-fluid" />
                                <div className="sc-bottom">
                                    <h5>{value.Title}</h5>
                                    <p>{value.Description}</p>
                                </div>
                                </a>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className="steps steps-bottom">
                <ul className="steps-list">
                    <li><a href={this.state.Step1Link ? this.state.Step1Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step1}</a></li>
                    <li><a href={this.state.Step2Link ? this.state.Step2Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step2}</a></li>
                    <li><a href={this.state.Step3Link ? this.state.Step3Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step3}</a></li>
                    <li><a href={this.state.Step4Link ? this.state.Step4Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step4}</a></li>
                    <li><a href={this.state.Step5Link ? this.state.Step5Link : "#"} target={this.state.OpenInNewWindow ? "_blank" : "_self"}>{this.state.Step5}</a></li>

                </ul>
            </div>
        </section>
    }
}






// WEBPACK FOOTER //
// ./Views/src/Applicant/opportunities.tsx